import API from '../../../common/http/api.fetch';
import {success, responseMessage} from '../../../common/utils/util.notifier';
import * as GRID from '../../../common/grid/grid.constants';
import { TYPES } from './settings-action-type.constants';
import { IDS } from './settings-action-id.constants';
import I18N from '../../../common/utils/util.i18n';
import {GRID_RELOAD, GRID_FETCH} from "../../../common/grid/grid.constants";

export const getRegulatoryFrameworkDetails = (code) => {
    return dispatch => {
        return API.fetch({
            url:    '/rco/get-regulatory-framework-details',
            method: 'GET',
            params: { code }
        }).then(({data}) => {
            const details = data[0];
            const key = `ACCREDITATION.SETTINGS.SCHEME.STATUS_${details.status_code.toUpperCase()}`
            let status_name = I18N.translate(key);
            if(status_name === key)
                status_name = details.status_name;
            let module_prefixes_text = JSON.parse(details.module_prefixes);
            if(module_prefixes_text?.length)
                module_prefixes_text = module_prefixes_text.join(',');

            dispatch({
                type:   TYPES.SCHEME_DETAILS_REFRESH,
                id:     IDS.accreditationSettingsFrameworkDetails,
                data: {
                    ...details,
                    module_prefixes_text,
                    status_name,
                }
            });
            return details
        }, error => {
            responseMessage(error);
        });
    };
}

export const getSchemeStatus = (id) => {
    return dispatch => {
        return API.fetch({
            url:    '/rco/get-regulatory-framework-details',
            method: 'GET',
            params: {id: id}
        }).then(({data}) => {
            const details = data[0];
            const key = `ACCREDITATION.SETTINGS.SCHEME.STATUS_${details.status_code.toUpperCase()}`
            let status_name = I18N.translate(key);
            if(status_name === key)
                status_name = details.status_name;
            dispatch({
                type:   TYPES.SCHEME_STATUS_REFRESH,
                id:     IDS.accreditationSettingsFrameworkDetails,
                data: {
                    ...details,
                    status_name,
                }
            })
        }, error => {
            responseMessage(error);
        });
    };
}

export const editRegulatoryFramework = (data) => {
    return dispatch => {
        return API.fetch({
            url:    '/rco/edit-regulatory-framework',
            method: 'POST',
            data:   data,
        }).then(response => {
            dispatch({ // update accreditationEditorframeworkDetails.title
                type:   TYPES.SCHEME_DETAILS_REFRESH,
                id:     IDS.accreditationSettingsFrameworkDetails,
                data:   data
            })
            success('ACCREDITATION.NOTIFICATIONS.SCHEME.EDIT')
        }, error => {
            responseMessage(error);
        })
    }
}

export const activateScheme = (schemeId) => {
    return dispatch => {
        return API.fetch({
            url:    '/rco/set-regulatory-framework-status',
            method: 'POST',
            data: {
                id: schemeId,
                code: 'act'
            },
        }).then(response => {
            success('ACCREDITATION.NOTIFICATIONS.SCHEME.ACTIVATE')
        }, error => {
            responseMessage(error);
        })
    }
}

export const deactivateScheme = (schemeId) => {
    return dispatch => {
        return API.fetch({
            url:    '/rco/set-regulatory-framework-status',
            method: 'POST',
            data: {
                id: schemeId,
                code: 'pen'
            },
        }).then(response => {
            success('ACCREDITATION.NOTIFICATIONS.SCHEME.DEACTIVATE')
        }, error => {
            responseMessage(error);
        })
    }
}

export const invalidateEvidenceGroup = (ard_id, path) => {
    return dispatch => {
        return API.fetch({
            url: '/rco/invalidate-evidence-group',
            method: 'POST',
            data: { ard_id }
        }).then(response => {
            success('COMMON.SERVER_RESPONSE.ITEM_DELETED');
            dispatch({
                type:   GRID_RELOAD,
                id:     IDS.accSettings,
                path,
            });
        }, error => {
            responseMessage(error);
        })
    }
}

export const assignEvidenceGroupToFrameworkRequirement = (ard_id, ase_id, path) => {
    return dispatch => {
        return API.fetch({
            url:    '/rco/assign-evidence-group-to-requirement',
            method: 'POST',
            data:   {
                ard_id,
                ase_id
            }
        }).then(response => {
            success('COMMON.SERVER_RESPONSE.ITEM_ASSIGNED');
            dispatch({
                type:   GRID_RELOAD,
                id:     IDS.accSettings,
                path,
            });
        }, error => {
            responseMessage(error);
        })
    }
}

export const detachEvidenceGroupFromRequirement = (ard_id, ase_id, path) => {
    return dispatch => {
        return API.fetch({
            url:    '/rco/detach-evidence-group-from-requirement',
            method: 'POST',
            data:   {
                ard_id,
                ase_id,
            },
        }).then(response => {
            success('COMMON.SERVER_RESPONSE.ITEM_DETACHED');
            dispatch({
                type:   GRID_RELOAD,
                id:     IDS.accSettings,
                path,
            });
        }, error => {
            responseMessage(error);
        })
    }
}

export const fetchEvidenceGroupRequirementsGrid = (filter) => {
    return dispatch => {
        return API.fetch({
            url:    '/rco/list-evidence-group-requirements-grid',
            method: 'GET',
            params: {
                ard_id: filter.ard_id
            },
        }).then(({data}) => {
            dispatch({
                type:   GRID_FETCH,
                id:     IDS.accSettings,
                path:   filter.path,
                items:  data,
            });
        }, error => {
            responseMessage(error);
        })
    }
}

export const fetchGeneratorTypes = () => {
    return dispatch => {
        return API.fetch({
            url:    '/accreditation/list-generator-types',
            method: 'GET',
            params: {par_code: 'assgen'}
        }).then(({data}) => {
            data.unshift({code: 'disabled', name: 'Disabled'});
            dispatch({
                type:   TYPES.FETCH_GENERATOR_TYPES,
                id: IDS.accSettings,
                data: data
                    .filter(i => i.description !== 'disabled')
                    .map(item => {
                        const key = `ACCREDITATION.GENERATOR_TYPES.${item.code.toUpperCase()}`;
                        const fallback = item.name;
                        return {
                            value: item.code,
                            label: I18N.translate(key, fallback)
                    }}),
            });
        }, error => {
            responseMessage(error);
        });
    };
}